import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ModalBody, ModalFooter } from 'reactstrap'

import CustomModal from './../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

export default function ManageLTI(props) {
  useEffect(() => {
    props.fetchLtiContent(props.match.params.id)
    return () => {
      props.resetLtiFields()
    }
  }, [])

  const lti = props.content.find((item) =>
    item.id === parseInt(props.match.params.id) ? item : null
  )
  let language = props.language || {}

  return (
    <CustomModal courseId={props.course_id} title='Edit LTI' size='lg'>
      <ModalBody>
        <div className='row'>
          <div className='col-12'>
            <div className='lti-row'>
              <label>
                {language.settings ? language.settings.title : null}: *
              </label>
              <input
                type='text'
                name='title'
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
            <div className='lti-row'>
              <label>{'URL'}: *</label>
              <input
                type='text'
                name='launchUrl'
                value={props.launchUrl ? props.launchUrl : ''}
                onChange={(event) =>
                  props.onChangeLaunchUrl(event.target.value)
                }
              />
            </div>
            <div className='lti-row'>
              <label>
                {language.courses ? language.courses.consumer_key : null}: *
              </label>
              <input
                type='text'
                name='consumerKey'
                value={props.consumerKey || ''}
                onChange={(event) =>
                  props.onChangeConsumerKey(event.target.value)
                }
              />
            </div>
            <div className='lti-row'>
              <label>
                {language.courses ? language.courses.shared_secret : null}: *
              </label>
              <input
                type='text'
                name='sharedSecret'
                value={props.sharedSecret || ''}
                onChange={(event) =>
                  props.onChangeSharedSecret(event.target.value)
                }
              />
            </div>
            <div className='lti-row'>
              <label>
                {language.courses ? language.courses.custom_parameters : null}:{' '}
              </label>
              <textarea
                name='customParameters'
                rows='4'
                value={props.customParameters || ''}
                onChange={(event) =>
                  props.onChangeCustomParameters(event.target.value)
                }
                style={{ resize: 'none' }}
              ></textarea>
            </div>

            <div className='custom-control custom-checkbox-info mt-2'>
              <input
                className='custom-control-input'
                id='required_content'
                type='checkbox'
                checked={lti ? lti.required : false}
                onChange={() => props.setContentRequired(lti.id)}
              />
              <label
                className='custom-control-label '
                htmlFor='required_content'
                style={{ fontSize: '14px', paddingTop: '2px' }}
              >
                {language?.courses?.required}
              </label>
            </div>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className='d-flex justify-content-start mt-3'>
        {props.title &&
        props.launchUrl &&
        props.consumerKey &&
        props.sharedSecret ? (
          <Link to={`/course/${props.id}/edit`}>
            <SubmitModalButton
              text={language.general ? language.general.submit : null}
              customFn={() => props.saveLTI(lti.id)}
            />
          </Link>
        ) : (
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.saveLTI(lti.id)}
          />
        )}
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(lti.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}
